
// 图纸内的经常用的一些公共方法
import mongeApiMlib from "./../mongeApiMlib";
import { mongeApp, mongeMutations } from "./../store/mongeStore";
import mongeService from "./../service/monge-service";
import Kscreenshot from "@/CommonDP/utils/kscreenshot/src/kss";
import Vue from "vue";

export default {
  hasDwg() {
    return mongeApp.model.hasDwg;
  },
  modelPageFileName() {
    return mongeApp.model.modelPageFileName;
  },
  modelInfoData() {
    return JSON.parse(mongeApp.model.fileInfo);
  },
  mlibEnabled() {
    return mongeApp.mlibEnabled;
  },
  modelAllFileList() {
    return mongeApp.model.allFileList;
  },
  // 状态字典
  statusList() {
    return mongeApp.dicList?.statusList || [];
  },
  // 获取问题状态颜色
  getAnnotationColor(queStatus, dicList) {
    let color = "";
    switch (queStatus) {
      case dicList[0].cnName:
        color = Number("0xEB5757");
        break;
      case dicList[1].cnName:
        color = Number("0xEAC100");
        break;
      case dicList[2].cnName:
        color = Number("0x8B8888");
        break;
      case dicList[3].cnName:
        color = Number("0x00B632");
        break;
      default:
        color = Number("0xCCCCCC");
        break;
    }
    return color;
  },
  // 展示当前空间的所有云线
  showAllAnnotation(list, statusList, type) {
    if (type === "dwg") {
      for (const element of list) {
        const color = this.getAnnotationColor(element.queStatus, statusList);
        if (element.layoutName === JSON.parse(mongeApp.map.spaceOfDwgData)) {
          const data = element.source === "WEB端" || element.source === "APP端" ? JSON.parse(element.coordinate) : JSON.parse(element.anchorPoint);
          mongeApiMlib.annoShow(element.questionId, data, color);
        }
      }
    } else if (type === "model") {
      for (const element of list) {
        const color = this.getAnnotationColor(element.queStatus, statusList);
        if (element.flag23d === 1) { // 锚点
          const data = JSON.parse(element.coordinate);
          data.color = color;
          mongeApiMlib.showMark(element.questionId, data);
        } else if (element.modelPageFileName === this.modelPageFileName()) { // 云线
          const data = element.source === "WEB端" || element.source === "APP端" ? JSON.parse(element.coordinate) : JSON.parse(element.anchorPoint);
          mongeApiMlib.annoShow(element.questionId, data, color);
        }
      }
    }
  },
  async getDicList(prjId, flowInstanceId) {
    const res = await mongeService.getFilterDic(prjId, "", flowInstanceId);
    mongeMutations.setDicList(res.data);
  },
  async getNotationData(questionId, userId, type, flowInstanceId, shareId) {
    const res = await mongeService.getDrawingQuestionDetails(questionId, userId, flowInstanceId, shareId);
    this.modelFitToH5(res.data, this.statusList(), type);
  },

  async modelFitToH5(item, statusList, type) {
    if (type === "dwg") {
      this.fitToQs(item, statusList, type);
    } else {
      if (item.flag23d === 1) { // 模型
        const color = this.getAnnotationColor(item.queStatus, statusList);
        const data = JSON.parse(item.coordinate);
        data.color = color;
        mongeMutations.setHasDwg(false);
        await Vue.nextTick();
        mongeApiMlib.resize();
        mongeApiMlib.modelAim(item.questionId, data, item.viewPoint);
      } else if (item.flag23d === 2) { // 图纸
        mongeMutations.setHasDwg(true);
        mongeMutations.setModelPageFileName(decodeURIComponent(item.modelPageFileName));
        mongeMutations.setModelMapData(item);
      }
    }
  },
  // 模型图纸定位
  modelmapFitToH5(item, statusList) {
    const data = item.source === "WEB端" || item.source === "APP端" ? JSON.parse(item.coordinate) : JSON.parse(item.anchorPoint);
    const color = this.getAnnotationColor(item.queStatus, statusList);
    mongeApiMlib.mapAim(item.questionId, data, color);
    mongeMutations.setAnnotationData("");// 清空云线数据加颜色
  },
  // 图纸、模型定位
  fitToQs(item, statusList, type) {
    if (type === "dwg") {
      if (item.layoutName === JSON.parse(mongeApp.map.spaceOfDwgData)) {
        const data = item.source === "WEB端" || item.source === "APP端" ? JSON.parse(item.coordinate) : JSON.parse(item.anchorPoint);
        const color = this.getAnnotationColor(item.queStatus, statusList);
        mongeApiMlib.mapAim(item.questionId, data, color);
        mongeMutations.setAnnotationData("");// 清空云线数据加颜色
      } else {
        mongeMutations.setAnnotationData(item);// 清空云线数据加颜色
        mongeMutations.setSpaceOfDwgData(JSON.stringify(item.layoutName));// 切换空间
      }
    } else if (type === "model") {
      const color = this.getAnnotationColor(item.queStatus, statusList);
      const fileName = item.fileName;
      if (item.flag23d === 1) { // 锚点
        const data = JSON.parse(item.coordinate);
        data.color = color;
        const callback = ()=>{
          this.sectionSet(item);
        }; // 回调方法
        mongeApiMlib.modelAim(item.questionId, data, item.viewPoint, fileName, callback);
      } else { // 模型图纸
        // 打开的模型图纸和批注定位的图纸相同
        if (item.modelPageFileName === this.modelPageFileName()) {
          const data = item.source === "WEB端" || item.source === "APP端" ? JSON.parse(item.coordinate) : JSON.parse(item.anchorPoint);
          mongeApiMlib.mapAim(item.questionId, data, color);
        } else { // 打开的模型图纸和批注定位的图纸不同
          this.loadMapList(item, color);
        }
      }
    }
  },
  // 设置剖切状态（model）
  async sectionSet(item){
    const { sectionPos } = item || {};
    let { type, box } = sectionPos || {};
    if(type) {
      await mongeApiMlib.section3D(type, true, true, true);
      let allowTypes = ['x', 'y', 'z', 'box'];
      if(allowTypes.includes(type)) mongeApiMlib.setSectionPos(type, box);
    } 
  },
  // 引擎截图
  async startScreenShot(type) {
    const canvas = await mongeApiMlib.mongeScreenCapture(true, type);
    return new Promise((resolve) => {
      let cutpic = "";
      const kss = new Kscreenshot({
        endCB: imgs => {
          cutpic = imgs;
          resolve(cutpic);
        }
      });
      kss.startScreenShot(canvas);
    });
  },
  // 读取模型图纸文件列表=>找的对应图纸=>定位云线
  async loadMapList(item, color) {
    if (this.mlibEnabled()) {
      await this.getIsOssList(item);
    } else {
      await this.getOldList(item);
    }
    // 添加云线
    const data = item.source === "WEB端" || item.source === "APP端" ? JSON.parse(item.coordinate) : JSON.parse(item.anchorPoint);
    mongeApiMlib.mapAim(item.questionId, data, color);
  },
  // 新加载打开图纸
  async getIsOssList(data) {
    /**
     * @param {drawName}  图纸名称
     * @param {fileName} 模型名称（有后缀）
     */
    const { modelPageFileName: drawName, fileName } = data;
    const models = await mongeApiMlib.getModels();
    // 去掉模型名称后缀
    const name = fileName.substring(0, fileName.lastIndexOf("."));
    const modelId = models.find(e => decodeURIComponent(e.cnName) === decodeURIComponent(name)).id;
    const url = this.modelAllFileList().filter(item => item.drawName === drawName && item.label === "2D");
    console.log(url);
    const bimexDetailList = [];
    url.forEach(e => {
      if (!e.drawName) return;
      const bimexItemFile = {
        originFileName: e.lightFileName,
        url: e.downloadUrl,
        fileId: e.fileId
      };
      bimexDetailList.push(bimexItemFile);
    });
    const spaceWithDetailItems = {
      bimexId: drawName,
      bimexName: drawName,
      convertFilePathId: drawName,
      bimexDetailList
    };
    const params = { url: spaceWithDetailItems, id: 'dwgbox', longforLoading: false, modelId };
    mongeMutations.setHasDwg(true);
    mongeMutations.setModelPageFileName(decodeURIComponent(drawName));
    await Vue.nextTick();
    await mongeApiMlib.load2D(params);
  },
  async getOldList(item) {
    const name = item.modelPageFileName;
    let mapList;
    if (this.modelInfoData()?.fileObj) { // 多文件
      mapList = await this.multiMaps();
    } else if (this.modelInfoData()?.fileId) { // 单文件
      mapList = await this.singleMap();
    }
    const nowData = mapList.find(e => decodeURIComponent(e.picName) === name);
    // 打开图纸
    const { picsurl: url, modelFileId, rvtVersion } = nowData;
    await this.openmodelDwg(url, name, modelFileId, rvtVersion);
  },
  async multiMaps() {
    let groupPics;
    for (const iterator of this.modelInfoData()?.fileObj) {
      const list = await this.getDwgList(iterator.folderID, iterator.rvtVersion);
      groupPics = [...groupPics, ...list];
    }
    return groupPics;
  },
  async singleMap() {
    const fileId = this.modelInfoData()?.fileId;
    const rvtVersion = this.modelInfoData()?.rvtVersion || "";
    return await this.getDwgList(fileId, rvtVersion);
  },
  async getDwgList(fileId, rvtVersion) {
    const { data } = await mongeService.queryDwgList(fileId, rvtVersion);
    const list = mongeApiMlib.assembleMapUrl(data, fileId, rvtVersion);
    return list;
  },
  async openmodelDwg(url, picName, modelFileId, rvtVersion) {
    mongeMutations.setHasDwg(true);
    mongeMutations.setModelPageFileName(decodeURIComponent(picName));
    await Vue.nextTick();
    const params = {
      url,
      id: 'dwgbox',
      longforLoading: false,
      modelFileId,
      rvtVersion
    };
    await mongeApiMlib.load2D(params);
  }
};
